import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { ActionRow, Button, ModalDialog } from '@openedx/paragon';
import PropTypes from 'prop-types';

import { useT } from '../context/LanguageContext';

const ProgressiveProfilingPageModal = (props) => {
  const { t } = useT();
  const { isOpen, redirectUrl } = props;
  const platformName = getConfig().SITE_NAME;

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = redirectUrl;
  };

  return (
    <ModalDialog
      title={t('modal.title')}
      isOpen={isOpen}
      onClose={() => {}}
      size="sm"
      variant="default"
      hasCloseButton={false}
    >
      <ModalDialog.Header>
        <ModalDialog.Title>
          {t('modal.title')}
        </ModalDialog.Title>
      </ModalDialog.Header>

      <ModalDialog.Body>
        {t('modal.description')}
      </ModalDialog.Body>

      <ModalDialog.Footer>
        <ActionRow>
          <Button onClick={handleSubmit} variant="primary">
            {t('continue.to.platform', { platformName })}
          </Button>
        </ActionRow>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};

ProgressiveProfilingPageModal.propTypes = {
  isOpen: PropTypes.bool,
  redirectUrl: PropTypes.string.isRequired };

ProgressiveProfilingPageModal.defaultProps = {
  isOpen: false };

export default ProgressiveProfilingPageModal;
